import z from "zod";
import { ONBOARDING_GOALS, UserOnboardingFlow } from "../UserOnboarding/UserOnboarding.enum.js";

export const onboardingLoggedOutCookieFlowAZod = z.object({
    flow: z.literal(UserOnboardingFlow.A),
    selectedGoal: z.enum(ONBOARDING_GOALS).optional(),
});
export const onboardingLoggedOutCookieFlowBZod = z.object({
    flow: z.literal(UserOnboardingFlow.B),
    target: z
        .object({
            jobTitle: z.string(),
            country: z.string(),
            industries: z.array(z.string()),
        })
        .optional(),
});
export const onboardingLoggedOutCookieFlowCZod = z.object({
    flow: z.literal(UserOnboardingFlow.C),
});
export const onboardingLoggedOutCookieZod = z.discriminatedUnion("flow", [
    onboardingLoggedOutCookieFlowAZod,
    onboardingLoggedOutCookieFlowBZod,
    onboardingLoggedOutCookieFlowCZod,
]);
